<template>
	<div class="focusenterprises">
		<leftnav class="fl" mkcode="E" itemcode="E-ZZDT" :mkopen="true"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="index_left_centerpage whitebox" style="min-height: 95vh;">
				<div class="heightVh95 whitebox container-flex-center">
					<freeUserTips :type="4" :bgtype="0" isShowPageTitle="作战地图"></freeUserTips>
				</div>
			</div>
			</div>
		</div>
	</div>
</template>

<script>
	import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'mapserch',
		computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				title: "作战地图",
				userdata: {currentCity:{type:"city"}},curWebsite:this.$api.getWebsiteType(),calCuData:{},leftarrown:"控制企业和对外投资",
				clueType: 2,
				secondaryList: [],secondaryNameList:[],secondaryEmptyText:"",iscache:true,
				orderField: 16, //排序字段 16 招商算法分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序 
				page: 1, //显示的是哪一页 
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数   
				collecttype: 13,
				tabbtn: 1,
				maptype: 1,
				citymapdata: [],
				mapsmcityList: [],
				mapdata: [{
					name: "广东",
					value: 20,
					data: [{
						name: "深圳市",
						value: 15
					}]
				}, {
					name: "北京",
					value: 50,
					data: [{
						name: "朝阳区",
						value: 30
					}]
				}, ],
				flag: false,
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量 16=招商算法总分
				dimensionList: [{
					name: '综合',
					type: 0
				}, {
					name: '融资时间',
					type: 1
				}, {
					name: '企业实力',
					type: 2
				}, {
					name: '投资力度',
					type: 3
				}, {
					name: '本省关联度',
					type: 4
				}, {
					name: '拿地数量',
					type: 5
				}, {
					name: '拿地面积',
					type: 6
				}, {
					name: '拿地金额',
					type: 7
				}, {
					name: '投资项目数量',
					type: 8
				}, {
					name: '投资项目金额',
					type: 9
				}, ],
				dimesmlist: [{
					name: '总体评分',
					type: 16
				}, {
					name: '企业实力',
					type: 2
				}, {
					name: '投资力度',
					type: 3
				}, ],
				enternum: 0,
				// ,{name:'控制企业数量',type:10},{name:'专利数量',type:11},{name:'营业收入（亿元）',type:12},{name:'营收增速',type:13},{name:'净利润（亿元）',type:14},{name:'净利增速',type:15},

				// collecttype: [{
				// 	name: "产业机会",
				// 	type: 0
				// }, {
				// 	name: '龙头企业',
				// 	type: 1
				// }],
				chainlist: [],
				entercommlist: [],
				shorenterlist: [],
				academylist: [], //创新资源
				orglist: [], //投资机构
				topiclist: [], //专题 
				eventchain: [], //事件链
				policychain: [], //政策链 
				parkdata: [], //产业园区
				associationData: [], //协会
				commerceDate: [], //商会
				forcapenterlist: [], //外资企业
				foreignEnterList: [], //境外上市企业
				townlist: [], //专业镇
				RelatedList: [], //企业触达线索表格
				oneNameList: "", //一级线索里已有的企业名字
				exChildlist: [{
						title: '公司1',
						stockCode: 30750,
						address: "广东省深圳市福田区",
						phone: "0755-52415141"
					},
					{
						title: '公司2',
						stockCode: 30750,
						address: "广东省深圳市福田区",
						phone: "0755-52415141"
					},
					{
						title: '公司3',
						stockCode: 30750,
						address: "广东省深圳市福田区",
						phone: "0755-52415141"
					},
				],
				tipstext: '企业',
				tipsnum: 0,
				secondCompanyNum:0,
				firstCompanyNum:0,
			}
		},
		components: {
		 freeUserTips
		},
		created() {
			 
		},
		mounted() {},
		methods: {
			getlength(data,num){
				return this.userdata.isFree ? num : data.length;
			},
			pageHandler: function(page) {
				this.getEnterpriseRelated(this.clueType, page);
			},
			getcacheRelatedlist(cluetype){
				this.clueType=cluetype;
				if(this.iscache){
					this.getLevel2List('cache');
					this.iscache=false;
				}
			},
			//获取企业触达线索 二级线索 type=calcu 新计算 type=cache初始拿缓存
			getLevel2List(type,enterpriseName,stockcode){
				this.bus.$emit('loading', true);
				// this.clueType = 2;
				// this.page = pages ? pages : 1;
				var _this = this; 
				var ajaxurl=this.$api.cyl.collect.enterpriseRelatedLevel2();
				if(type == 'cache'){
					var namelist=[],nametext="";
					for(var i=0;i<this.secondaryNameList.length;i++){ 
						// if(this.iscache){
						// 	this.secondaryNameList[i].iscache=false;
						// } 
						namelist.push(this.secondaryNameList[i].stockCode)
					}
					nametext=namelist.join(',');
					ajaxurl=ajaxurl+'?cache='+nametext;
				}else{
					ajaxurl=ajaxurl+ '?stockCode=' + stockcode ;
				} 
				
				this.$axios.get(ajaxurl , {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('获取二级企业作战线索',ajaxurl,res.data);
					let reslist = res.data.list?res.data.list:[]; 
					// reslist=reslist.filter(list=>{
					// 	return list.num>0;
					// })   
					if(reslist.length>0){
						_this.handleRelatedList(reslist, 2);
						_this.secondaryEmptyText="计算结果";
					}else{
						if(type == 'cache'){
							_this.secondaryList=[];
							// _this.secondaryEmptyText="未找到对应关系";
						}else if(type == 'calcu'){ 
							var list={title:enterpriseName,stockCode:stockcode,children:[]};
								_this.secondaryList.push(list);
						} 
						// _this.secondaryEmptyText="未找到对应关系";
					}
					
					//页数和导出
					// _this.totalPage = res.data.totalPage;
					// _this.pageSize = res.data.pageSize;
					// _this.total = res.data.totalRecord;
					_this.bus.$emit('loading', false);
				
				})
			},
			//获取企业作战一级线索
			getEnterpriseRelated(level, pages) {
				this.bus.$emit('loading', true);
				this.clueType = level;
				this.page = pages ? pages : 1;
				var _this = this; 
				this.$axios.get(this.$api.cyl.collect.enterpriseRelated() + '?page=' + this.page + '&level=' + level, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('获取企业作战线索', res.data);
					let reslist = res.data.list?res.data.list:[];
					_this.handleRelatedList(reslist, level); 
					
					//页数和导出
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
					_this.bus.$emit('loading', false);

				})
			},
			
			//处理企业触达线索数据 
			handleRelatedList(datalist, level) {
				if (level == 1) {
					// console.log(datalist) 
					if(this.iscache){ 
							this.secondaryNameList=datalist.filter(list=>{
								return list.num==0;
							})
							if(this.secondaryNameList.length==0){
								this.secondaryEmptyText="暂无二级关系企业列表";
							}
					} 
					datalist=datalist.filter(list=>{
						return list.num>0;
					})  
					datalist=this.getDataName(datalist); 
				 var	oneNameList = "";
					for (var i = 0; i < datalist.length; i++) {
						oneNameList = oneNameList += '&' + datalist[i].title;
					}
						let exdata = [];
					for (var i = 0; i < datalist.length; i++) {
						// if (!datalist[i].isempty) {
							
							let smlist = {
								title: datalist[i].title,
								stockCode: datalist[i].stockCode,
								grade: 1,
								rowspan: 1,
								relationship: 'a',
								smtitle: "",
								smstockCode: 0,
								phone: "a",
								address: "a",
								isCounty:0,
							};
							let rowspannum = 0;
							for (var d = 0; d < datalist[i].children.length; d++) {
								let culist = datalist[i].children[d].list;
								smlist.relationship = datalist[i].children[d].relationship;
								for (var s = 0; s < culist.length; s++) {
									var isfirst = d == 0 && s == 0;
									if (!isfirst) {
										smlist.grade = 2;
									}
									// console.log(d,s,d == 0 && s == 0,smlist.grade)
									rowspannum++;
									smlist.smtitle = culist[s].title;
									smlist.smstockCode = culist[s].stockCode;
									smlist.phone = culist[s].phone;
									smlist.address = culist[s].address;
									smlist.rowspan = rowspannum;
									smlist.grade = isfirst ? 1 : 2;
									smlist.isCounty=culist[s].isCounty;
									let ddd = smlist;
									// console.log(smlist)
									exdata.push({
										title: datalist[i].title,
										stockCode: datalist[i].stockCode,
										grade: isfirst ? 1 : 2,
										rowspan: datalist[i].rowspanum,
										relationship: datalist[i].children[d].relationship,
										smtitle: culist[s].title,
										smstockCode: culist[s].stockCode,
										phone: culist[s].phone,
										address: culist[s].address,
										isCounty:culist[s].isCounty,
										middleList:culist[s].middleList,//机构、协会、商会之才有数据其他为 []
									})
								}
							}
						// }
					} 
					this.oneNameList = oneNameList;
					this.RelatedList = exdata;
					this.firstCompanyNum= this.userdata.isFree ? 1 : exdata.length;
				} else if (level == 2) {
					// let onelist = this.oneNameList;  
					// datalist = datalist.filter(list => {
					// 	return onelist.indexOf(list.title) < 0 && list.num>0;
					// })
					for(var d=0;d<this.secondaryNameList.length;d++){ 
						for(var i=0;i<datalist.length;i++){ 
								if(this.secondaryNameList[d].stockCode == datalist[i].stockCode){
										this.secondaryNameList[d].iscache=true;
								}
							}
					}
					datalist=this.getDataName(datalist);
			 
					for(var i=0;i<datalist.length;i++){
						let smdata=datalist[i].children;
						for(var d=0;d<smdata.length;d++){
							let smmdata=smdata[d].list;
							smdata[d].list=this.getDataNameL2(smmdata,'l2'); 
						}
					} 
					
					// console.log('二级线索1遍历', datalist);
     this.secondaryList=this.secondaryList.concat(datalist);
					this.secondCompanyNum=this.userdata.isFree ? 1 : this.secondaryList.length;
					console.log('二级线索1遍历',this.secondaryList)
				}
				this.bus.$emit('loading', false);
			},
			getDataNameL2(datalist){
				//第二级和第一级格式不同
				for(var i=0;i<datalist.length;i++){  
					var onelevelData = datalist[i].data,rowspanum=0;  
					
					datalist[i].children=[]; 
						if(onelevelData.controlEnterprise){
							for(var d=0;d<onelevelData.controlEnterprise.length;d++){
								let smdata=onelevelData.controlEnterprise[d];
								smdata.relationship="控制企业";
								datalist[i].children.push(smdata);
								rowspanum++;
							}
						}
					if(onelevelData.customer){
					for(var d=0;d<onelevelData.customer.length;d++){
						let smdata=onelevelData.customer[d];
						smdata.relationship="客户";
						datalist[i].children.push(smdata);
						rowspanum++;
					}
					}
					if(onelevelData.invest){
					for(var d=0;d<onelevelData.invest.length;d++){
						let smdata=onelevelData.invest[d];
						smdata.relationship="对外投资";
						datalist[i].children.push(smdata);
						rowspanum++;
					}}
					if(onelevelData.shareholder){
					for(var d=0;d<onelevelData.shareholder.length;d++){
						let smdata=onelevelData.shareholder[d];
						smdata.relationship="股东";
						datalist[i].children.push(smdata);
						rowspanum++;
					}
					}
					if(onelevelData.supplier){
					for(var d=0;d<onelevelData.supplier.length;d++){
						let smdata=onelevelData.supplier[d];
						smdata.relationship="供应商";
						datalist[i].children.push(smdata);
						rowspanum++;
					} 
					datalist[i].rowspanum = rowspanum; 
				}
				if(onelevelData.org){
					for(var d=0;d<onelevelData.org.length;d++){
						let smdata=onelevelData.org[d];
						smdata.relationship="投资机构";
						datalist[i].children.push(smdata);
						rowspanum++;
					} 
					datalist[i].rowspanum = rowspanum; 
				}
				if(onelevelData.commerce){
					for(var d=0;d<onelevelData.commerce.length;d++){
						let smdata=onelevelData.commerce[d];
						smdata.relationship="商会";
						datalist[i].children.push(smdata);
						rowspanum++;
					} 
					datalist[i].rowspanum = rowspanum; 
				}
				if(onelevelData.association){
					for(var d=0;d<onelevelData.association.length;d++){
						let smdata=onelevelData.association[d];
						smdata.relationship="协会";
						datalist[i].children.push(smdata);
						rowspanum++;
					} 
					datalist[i].rowspanum = rowspanum; 
				}
				
				
				
				}
				return datalist;
				
				
				
			},
			getDataName(datalist){ 
				for(var i=0;i<datalist.length;i++){ 
					var defautData={controlEnterprise:[],customer:[],invest:[],shareholder:[],supplier:[]};
					var onelevelData = datalist[i].data?datalist[i].data : defautData,rowspanum=0;  
					datalist[i].children = [];  
					if (onelevelData.controlEnterprise && onelevelData.controlEnterprise.length > 0) {
						datalist[i].children.push({
							relationship: "控制企业",
							list: onelevelData.controlEnterprise
						});
						rowspanum += onelevelData.controlEnterprise.length;
					}
					if (onelevelData.customer && onelevelData.customer.length > 0) {
						datalist[i].children.push({
							relationship: "客户",
							list: onelevelData.customer
						})
						rowspanum += onelevelData.customer.length;
					}
					if (onelevelData.invest && onelevelData.invest.length > 0) {
						datalist[i].children.push({
							relationship: "对外投资",
							list: onelevelData.invest
						})
						rowspanum += onelevelData.invest.length;
					}
					if (onelevelData.shareholder && onelevelData.shareholder.length > 0) {
						datalist[i].children.push({
							relationship: "股东",
							list: onelevelData.shareholder
						})
						rowspanum += onelevelData.shareholder.length;
					}
					if (onelevelData.supplier && onelevelData.supplier.length > 0) {
						datalist[i].children.push({
							relationship: "供应商",
							list: onelevelData.supplier,
						})
						rowspanum += onelevelData.supplier.length;
					}
					if (onelevelData.org && onelevelData.org.length > 0) {
						datalist[i].children.push({
							relationship: "投资机构",
							list: onelevelData.org,
						})
						rowspanum += onelevelData.org.length;
					}
					if (onelevelData.commerce && onelevelData.commerce.length > 0) {
						datalist[i].children.push({
							relationship: "商会",
							list: onelevelData.commerce,
						})
						rowspanum += onelevelData.commerce.length;
					}
					if (onelevelData.association && onelevelData.association.length > 0) {
						datalist[i].children.push({
							relationship: "协会",
							list: onelevelData.association,
						})
						rowspanum += onelevelData.association.length;
					}
					datalist[i].rowspanum = rowspanum; 
				}
				return datalist;
			},
			chartmapclick(response) {
				// console.log('chartmapclick',response)
			},
			choosecity(response) {
				// console.log('choosecity',response)
			},
			changCollectMap(maptype) {
				if (this.flag) {
					const chart = echarts.init(document.getElementById('chain_map_provience'));
					chart.showLoading({
						text: 'loading',
						color: '#3A568E',
						textColor: '#000',
						maskColor: 'rgba(255, 255, 255, 1)',
						zlevel: 1,
					});
					var chartcity = echarts.init(document.getElementById('chain_map_city'));
					chartcity.clear();
				}
				this.maptype = maptype;
				this.mapdata = [];
				var _this = this;
				var ajaxurl = this.$api.cyl.collect.map() + '?type=' + maptype;
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log(res.data)
					if (res.data.success) {
						var citylistd = [],
							citytest = res.data.cityList;
						for (var i = 0; i < citytest.length; i++) {
							let citylista = {};
							citylista.value = citytest[i].num;
							citylista.id = citytest[i].id;
							citylista.name = _this.citynameremove(citytest[i].name);
							citylista.data = [];
							for (var p = 0; p < citytest[i].children.length; p++) {
								let citydtac = {};
								citydtac.value = citytest[i].children[p].num;
								citydtac.id = citytest[i].children[p].id;
								citydtac.name = citytest[i].children[p].name;
								citylista.data.push(citydtac);
							}
							citylistd.push(citylista);
						};
						_this.mapsmcityList = res.data.list;
						// citylistd=[];
						if (citylistd.length == 0) {
							_this.citymapdata = [{
								name: "背景",
								value: 0
							}];
						} else {
							_this.citymapdata = citylistd;
						}

						_this.flag = true;

					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
		},
	}
</script>

<style scoped lang="scss">
	.user_tabtitle1{
	 height: 38px;line-height: 38px;margin-bottom: 32px;
	}
.user_tabtitle1 li{
	 width: calc(50% - 4px);text-align: center;cursor: pointer;  font-size: 16px;text-align: center;	border:1px solid #5E83CC;
	&.current,&:hover{
		background: #5E83CC;color: #fff; 
	}
}
.secondarylist li{
	width: 29%;height: 32px;line-height: 32px;margin-bottom: 20px;float: left;margin-right: 2%;margin-left: 1%;
}
.caculatBtn{
	width: 80px;
	&.basebtn{
		background: #5E83CC;color: #fff;cursor: pointer;
	}
}
.secondaryEmptyText{
	text-align: center;height: 42px;line-height: 42px;background: #d4e0f8;margin-bottom: 30px;margin-top:30px;
}
 
		
</style>
